import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import 'dayjs/locale/de';
import 'dayjs/locale/de-at';
import 'dayjs/locale/de-ch';
import 'dayjs/locale/fr';
import 'dayjs/locale/fr-ch';
import 'dayjs/locale/it';
import 'dayjs/locale/nl-be';
import 'dayjs/locale/nl';

import { Locale } from '../enums/Locale';

dayjs.extend(localizedFormat);

const enum DayJsLocale {
  De = 'de',
  De_At = 'de-at',
  De_Ch = 'de-ch',
  Fr = 'fr',
  Fr_Ch = 'fr-ch',
  It = 'it',
  Nl_Be = 'nl-be',
  Nl = 'nl',
}

export const getDayJsLocale = (locale: Locale) => {
  switch (locale) {
    case Locale.De_At:
      return DayJsLocale.De_At;
    case Locale.De_Ch:
      return DayJsLocale.De_Ch;
    case Locale.Fr_Fr:
    case Locale.Fr_Be:
      return DayJsLocale.Fr;
    case Locale.Fr_Ch:
      return DayJsLocale.Fr_Ch;
    case Locale.It_It:
      return DayJsLocale.It;
    case Locale.Nl_Be:
      return DayJsLocale.Nl_Be;
    case Locale.Nl_Nl:
      return DayJsLocale.Nl;
    default:
      return DayJsLocale.De;
  }
};
